module.exports = __webpack_public_path__ + "static/img/Check-in.73d5084.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icon/Check-in.png
// module id = iam+
// module chunks = 2